export default {
  NavAreaCategorys: [], // 地区聚类导航
  searchresult: [], // 检索列表
  IndexTopicCatagorys: [],
  queryInfo: JSON.parse(localStorage.getItem(`queryInfo`)) || '',
  indexNavList: [],
  filterShowList: JSON.parse(localStorage.getItem(`filterShowList`)) || [], // 筛选条件
  filterQueryist: JSON.parse(localStorage.getItem(`filterQueryist`)) || [], // 筛选条件
  userinfo: JSON.parse(localStorage.getItem(`userinfo`)) || {}, // userinfo
  detailInfoArr: {},
  currentPage: JSON.parse(localStorage.getItem(`currentPage`)) || 1,
  book_id: JSON.parse(localStorage.getItem(`bookId`)) || 0,
  upCouter: JSON.parse(localStorage.getItem(`count`)) || 0,
  readingType: JSON.parse(localStorage.getItem(`itemType`)) || -1
}



// WEBPACK FOOTER //
// ./src/store/state.js